@let paragraphColor = style().textColor | color;
<section [style.background-color]="style().backgroundColor | color">
  <div class="container">
    @if (breakpoints() === "mobile") {
      <div class="row">
        <div class="col-xs-12 col-lg-12">
          @if (title()) {
            <app-title [titles]="[title()]" class="title-section" />
          }
        </div>
      </div>
    }
    <div class="row">
      @if (breakpoints() === "desktop") {
        <aside class="col-lg-5 sticky">
          @if (title()) {
            <app-title [titles]="[title()]" class="title-section" />
          }
          @for (item of items(); track item; let i = $index) {
            @if (item.title; as title) {
              <span (click)="goToSection(item.title.text)" class="link">
                <app-title [class.title--active]="i === activeTitle()" [titles]="[title]" class="title" />
              </span>
            }
          }
        </aside>
      }
      <div class="col-xs-12 col-lg-7">
        @for (item of items(); track item) {
          @if (item.title; as title) {
            @if (breakpoints() === "mobile") {
              <app-title [titles]="[title]" />
            }
            @if (item.text; as text) {
              <p #paragraphElements [id]="title.text" [innerHTML]="text" [style.color]="paragraphColor"></p>
            }
          }
        }
      </div>
    </div>
  </div>
</section>
